import ENV from "../env";

const updateParticipant = async (participant) => {
  const response = await fetch(`${ENV.firebaseApiUrl}/participant/paid`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      participant
    }),
  });

  const resData = await response.json();

  if (!response.ok) {
    const errorMessage = resData?.error || resData?.message || "Unknown error";
    throw new Error("La confirmation de paiement n'a pas fonctionné :: " + errorMessage);
  }

  return true;
};

export default updateParticipant;
